var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.hideSiteChrome)?_c('JpHeader'):_vm._e(),_c('div',{class:['main-content', { 'main-content--bare': _vm.hideSiteChrome }]},[_c('router-view')],1),(!_vm.hideSiteChrome)?_c('FloatingDownloadQr'):_vm._e(),(!_vm.hideSiteChrome)?_c('JpFooter'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }